<template>
    <el-tag :type="tagType" :size="size" v-if="value || value === 0">
      {{ getLabel }}
    </el-tag>
    <span v-else>-</span>
  </template>
  
  <script>
  export default {
    name: "DictTag",
    props: {
      options: {
        type: Array,
        required: true
      },
      value: {
        type: [String, Number],
        default: ""
      },
      size: {
        type: String,
        default: "mini"
      }
    },
    computed: {
      // 获取状态标签类型
      tagType() {
        if (this.value === "0" || this.value === 0) return "success";
        if (this.value === "1" || this.value === 1) return "danger";
        return "info";
      },
      // 获取状态标签文本
      getLabel() {
        const item = this.options.find(item => item.value === this.value);
        return item ? item.label : "";
      }
    }
  };
  </script>